import { Typography } from "@mui/material";
import { icons } from "assets/AssetHelper";
import * as dayjs from "dayjs";

export const detailsData = ({ data, t }) => [
  {
    head: t("common.details"),
    icon: icons?.detailsIcon,
    details: [
      {
        label: t("wrappers_wrap_extras.name_en"),
        name: data?.localized_data?.en?.name,
      },
      {
        label: t("wrappers_wrap_extras.name_ar"),
        name: data?.localized_data?.ar?.name,
      },
      {
        label: t("wrappers_wrap_extras.width"),
        name: data?.dimensions?.width || 0,
      },
      {
        label: t("wrappers_wrap_extras.length"),
        name: data?.dimensions?.length || 0,
      },
      {
        label: t("wrappers_wrap_extras.height"),
        name: data?.dimensions?.height || 0,
      },
      {
        label: t("wrappers_wrap_extras.weight"),
        name: data?.weight || 0,
      },
      {
        label: t("wrappers_wrap_extras.extra_type"),
        name:
          {
            decorative_extra: t("wrappers_wrap_extras.extra_type_decorative"),
            personal_touch: t(
              "wrappers_wrap_extras.extra_type_personal_touch",
            ),
            both: t("wrappers_wrap_extras.extra_type_both"),
          }[data?.extra_type] || "-",
      },
      {
        label: t("wrappers_wrap_extras.requires_text"),
        name:
          data?.requires_text === true
            ? t("common.yes")
            : data?.requires_text === false
              ? t("common.no")
              : "-",
      },
      {
        label: t("wrappers_wrap_extras.text_max_length"),
        name: data?.text_max_length ?? "-",
      },
      {
        label: t("wrappers_wrap_extras.text_placeholder_en"),
        name:
          data?.localized_data?.en?.text_placeholder ||
          data?.text_placeholder ||
          "-",
      },
      {
        label: t("wrappers_wrap_extras.text_placeholder_ar"),
        name: data?.localized_data?.ar?.text_placeholder || "-",
      },
      {
        label: t("wrappers_wrap_extras.display_priority"),
        name: data?.display_priority ?? 0,
      },
    ],
  },
  {
    head: t("common.prices"),
    icon: icons?.priceIcon,
    details: [
      {
        label: t("wrappers_wrap_extras.price"),
        name: `${data?.price} ${data?.currency?.name}`,
        width: "30%",
      },
      {
        label: t("wrappers_wrap_extras.price_after_discount"),
        name: `${data?.price_after_discount} ${data?.currency?.name}`,
        width: "30%",
      },
      {
        label: t("wrappers_wrap_extras.quantity"),
        name: data?.count_on_hand,
        width: "30%",
      },
    ],
  },
  {
    head: t("details.dates"),
    icon: icons.datesIcons,
    details: [
      {
        label: t("details.created_at"),
        name: dayjs(data?.created_at).format("DD-MM-YYYY HH:MM a"),
      },
      {
        label: t("details.updated_at"),
        name: dayjs(data?.updated_at).format("DD-MM-YYYY HH:MM a"),
      },
    ],
  },
];
